<template>
  <BittsDrawer
    :visible="isVisible"
    :show-footer="false"
    :width="480"
    :destroy-on-close="true"
    :has-heading-border="true"
    header-classes="!items-start"
    header-margin="113px"
    wrapper-class="requests-drawer"
    @closed="close"
  >
    <template #headerTitle>
      <div class="flex flex-col gap-12 w-full">
        <h2 class="text-lg font-bold leading-[36px]">Requests</h2>
        <div class="flex items-end justify-between mr-[-44px]">
          <BittsSegment
            ref="segmentRef"
            :tabs="tabs"
            :initial-active-index="initialTabIndex"
            @change:segment="handleTabChange"
          />
          <BittsSelect
            v-model="view"
            :options="viewOptions"
            class="w-[145px] ml-auto"
            size="medium"
            :searchable="false"
            aria-label="View"
          />
        </div>
      </div>
    </template>
    <template #content>
      <RequestWidget
        role="tabpanel"
        aria-label="Requests"
        :tab="tab"
        :view="view"
        :accept-route-name="acceptRouteName"
        :close-route-name="closeRouteName"
        :can-edit-sharing-in-place="canEditSharingInPlace"
        @update:tab="handleWidgetTabReset"
        @partner-candidates-changed="emit('partner-candidates-changed')"
        @reinvite="emit('reinvite', $event)"
        @edit-sharing="emit('edit-sharing', $event)"
      />
    </template>
  </BittsDrawer>
</template>

<script setup lang="ts">
import { BittsDrawer, BittsSegment, BittsSelect } from '@crossbeam/bitts';

import RequestWidget from '@/components/dash/RequestWidget.vue';

import useRequestsDrawer from '@/composables/useRequestsDrawer';
import type { InboundShareRequest } from '@/types/data_share_requests';

const {
  openRouteName,
  closeRouteName,
  acceptRouteName,
  defaultView,
  canEditSharingInPlace = false,
} = defineProps<{
  openRouteName: string;
  closeRouteName: string;
  acceptRouteName: string;
  defaultView?: 'all' | 'partnerships' | 'data_share';
  canEditSharingInPlace?: boolean;
}>();

const emit = defineEmits<{
  'partner-candidates-changed': [];
  reinvite: [partner: { name: string; candidateId: string | null }];
  'edit-sharing': [request: InboundShareRequest];
}>();

const {
  isVisible,
  tab,
  view,
  segmentRef,
  tabs,
  viewOptions,
  initialTabIndex,
  badgeCount,
  open,
  close,
  handleTabChange,
  handleWidgetTabReset,
} = useRequestsDrawer({
  openRouteName,
  closeRouteName,
  acceptRouteName,
  defaultView,
});

defineExpose({ badgeCount, open });
</script>

<style lang="pcss">
@reference "../../css/theme.css";
.requests-drawer [data-testid='drawer-close-button'] {
  @apply h-36;
}
</style>
